import { CSSProperties, ReactElement } from 'react';

const styles: CSSProperties = {
	backgroundColor: '#EBECF0',
	width: '4px',
	borderRadius: '50px',
} as const;

export const CustomRenderThumbVertical = ({ style, ...props }: { style: CSSProperties }): ReactElement => (
	<div {...props} style={{ ...style, ...styles }} />
);
